module.exports = __webpack_public_path__ + "static/img/btn_1.f094419.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn_1.png
// module id = C5k6
// module chunks = 1